// extracted by mini-css-extract-plugin
module.exports = {"uploader":"PayBills_uploader__3O8Bc"};